// Request headers for the API. Signed out there is no token, so no
// Authorization header: "Bearer null" fails to decode, and the server's
// optional-JWT routes (a pack page, the pack list, a loop link) refuse an
// undecodable token with 401 where they accept a missing one.
export function apiHeaders(token) {
  const headers = { "Content-Type": "application/json" };
  if (typeof token === "string" && token && token !== "null" && token !== "undefined") {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
